/* unplugin-vue-components disabled */import { render } from "./CommunityCard.vue?vue&type=template&id=393c7796"
import script from "./CommunityCard.vue?vue&type=script&lang=js"
export * from "./CommunityCard.vue?vue&type=script&lang=js"

import "./CommunityCard.vue?vue&type=style&index=0&id=393c7796&lang=css"

import exportComponent from "/root/steemboylikegirlClub/gitproject/steemboylikegirlclub/steemboylikegirlclub/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__